import ContactUsPage from "@/views/ContactUs/ContactUsPage.vue";
import HomePage from "@/views/Home/HomePage.vue";
import NewsEventDetailPage from "@/views/NewsEvent/NewsEventDetailPage.vue";
import NewsEventPage from "@/views/NewsEvent/NewsEventPage.vue";
import CentralMonitoringResponseServicePage from "@/views/OurService/CentralMonitoringResponseServicePage.vue";
import ElectronicSecuritySystemPage from "@/views/OurService/ElectronicSecuritySystemPage.vue";
import GuardingSecurityServicePage from "@/views/OurService/GuardingSecurityServicePage.vue";
import SecurityTrainingPage from "@/views/OurService/SecurityTrainingPage.vue";
import {createRouter, createWebHistory} from "vue-router";

const routes = [
    {
        path: "/",
        name: "HomePage",
        component: HomePage,
    },
    {
        path: "/contact-us",
        name: "ContactUsePage",
        component: ContactUsPage,
    },
    {
        path: "/news-event",
        name: "NewsEventPage",
        component: NewsEventPage,
    },
    {
        path: "/news-event-detail/:id",
        name: "NewsEventDetailPage",
        component: NewsEventDetailPage,
    },
    {
        path: "/our-service/guarding-security-service",
        name: "GuardingSecurityServicePage",
        component: GuardingSecurityServicePage,
    },
    {
        path: "/our-service/electronic-security-system",
        name: "ElectronicSecuritySystemPage",
        component: ElectronicSecuritySystemPage,
    },
    {
        path: "/our-service/central-monitoring-response-service",
        name: "CentralMonitoringResponseServicePage",
        component: CentralMonitoringResponseServicePage,
    },
    {
        path: "/our-service/security-training",
        name: "SecurityTrainingPage",
        component: SecurityTrainingPage
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {top: 0};
        }
    },
});

export default router;
